





import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/Base/BaseIcon";

export default defineComponent({
  name: "ContentFeedReviews",
  components: { BaseIcon },
  props: {
    reviewsStatsCount: { type: Number, default: 0 },
  },
});
